module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pre2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pre3"
    }
  }, [_vm._v("Characters in the Drama")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_vm._v("1 New Year’s Day"), _c('br'), _c('span', {
    staticClass: "tab"
  }), _c('i', [_vm._v("1 Kaisaros, 9 Kalends October")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1#niv1-001"
    }
  }, [_vm._v("The Divine Artemis Sends Birthday Wishes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1#enc-001"
    }
  }, [_c('i', [_vm._v("Musical Instruments in the Roman Period")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1#enc-006"
    }
  }, [_c('i', [_vm._v("Roman Asia’s Calendar")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1#niv1-002"
    }
  }, [_vm._v("A Symposium in the Prytaneion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1#enc-007"
    }
  }, [_c('i', [_vm._v("The Title Neōkoros")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Roman Piety, Roman Peace"), _c('br'), _c('span', {
    staticClass: "tab"
  }), _c('i', [_vm._v("2 Kaisaros, 8 Kalends October")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#niv1-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Serapion’s Townhouse")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#niv1-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Harbor of Ephesus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#enc-008",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Titus Flavius Zeuxis")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#enc-009",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Jewish Community of Ephesus")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#niv1-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The City Fathers Convene")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#enc-010",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Third Horseman and Domitian’s Edict")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#enc-011",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Staff of the Imperial Cult")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 In the Shadow of the Gods"), _c('br'), _c('span', {
    staticClass: "tab"
  }), _c('i', [_vm._v("3 Kaisaros, 7 Kalends October")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#niv1-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asia’s Shared Temple of the Augusti in Ephesus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#enc-012",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Civic Pride and Imperial Cult")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#niv1-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Shade of the Basilica Stoa")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#niv1-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Merchants’ Quarter")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#enc-015",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Aelius Aristides on the Roman Imperial Economy")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Lord’s Day"), _c('br'), _c('span', {
    staticClass: "tab"
  }), _c('i', [_vm._v("4 Kaisaros, 6 Kalends October")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#niv1-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morning Orisons")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#enc-016",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Christian Worship at the Turn of the First Century CE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#niv1-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Great Theater")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#enc-017",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Imperial Cult in the Games of Neapolis")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#niv1-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Assembly in Amyntas’s House")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#enc-018",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Varieties of Christianity in Ephesus")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Crucible of Faith"), _c('br'), _c('span', {
    staticClass: "tab"
  }), _c('i', [_vm._v("5 Kaisaros, 5 Kalends October")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5#niv1-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Serapion’s Townhouse")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5#niv1-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Gymnasium")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5#niv1-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prochorus Arrives")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5#enc-019",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("John’s Removal to Patmos")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Day of Decision"), _c('br'), _c('span', {
    staticClass: "tab"
  }), _c('i', [_vm._v("6 Kaisaros, 4 Kalends October")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The View from Above")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6#enc-020",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Domitian’s Diminished Popularity and"), _c('br'), _vm._v("Ephesus’s Flavian Temple")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Council Chamber")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6#enc-021",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Fiscus Iudaicus and the “Synagogue of Satan”")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The Day After"), _c('br'), _c('span', {
    staticClass: "tab"
  }), _c('i', [_vm._v("7 Kaisaros, 3 Kalends October")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Business as Usual")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Grace Defaced")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Study")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("A Week in the Life of Ephesus")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ad39d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/sommaire.vue
// module id = 63
// module chunks = 0